var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_5699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.733 12.7668L40.5912 16.9086C40.169 17.3308 39.4862 17.3308 39.0639 16.9086L29.0912 6.93591C28.669 6.51365 28.669 5.83083 29.0912 5.40857L33.233 1.26677C34.9131 -0.413306 37.6444 -0.413306 39.3334 1.26677L44.733 6.66638C46.4221 8.34646 46.4221 11.0777 44.733 12.7668ZM25.5334 8.96638L1.94045 32.5593L0.0357618 43.4754C-0.224785 44.9488 1.05998 46.2246 2.53342 45.973L13.4494 44.0593L37.0424 20.4664C37.4647 20.0441 37.4647 19.3613 37.0424 18.939L27.0697 8.96638C26.6385 8.54412 25.9557 8.54412 25.5334 8.96638ZM7.90607 38.0937H12.2186V41.3551L6.42365 42.3703L3.62951 39.5761L4.64475 33.7812H7.90607V38.0937Z",
    fill: "url(#paint0_linear_217_5699)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_5699",
    x1: 23.0009,
    y1: 0.00671387,
    x2: 23.0009,
    y2: 46.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_5699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.5f8deebe39c63533628b24074f26a4df.svg";
export { ForwardRef as ReactComponent };